// GuidanceChip — visible "your guidance is armed" pill on a re-draft card.
// Feb 27 2026 (Randy pt-ytre-guide-chip) — evolved from the original
// invisible design after Randy tested and wanted a reassurance
// indicator: "I wasn't assured that the curated comment I added played
// a significant role... add some sort of indication that the re-draft
// is being impacted by the capture pad thing."
//
// Renders next to the Re-draft button on YTRE owner cards, YTRE silo-
// response cards, and YT Replies drafts. Compact — 30-char preview +
// clear-X. Click the body to reopen the pad in edit mode (parent wires
// this via onEdit).
//
// Props:
//   guidance   — { text: string, persist: boolean } | null. When null,
//                nothing renders.
//   onEdit     — () => void; parent should open the pad prefilled.
//   onClear    — () => void; drops the guidance entirely.
//   testId     — data-testid suffix so E2E can distinguish surfaces.
import { Compass, X, MapPin } from "@phosphor-icons/react";

export default function GuidanceChip({ guidance, onEdit, onClear, testId }) {
  if (!guidance?.text) return null;
  const preview = guidance.text.length > 30 ? `${guidance.text.slice(0, 30)}…` : guidance.text;
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[10.5px] px-2 py-1 rounded-full border border-[#B8CCC0] bg-[#EDF3EE] text-[#2F5040] max-w-[220px]"
      data-testid={`guidance-chip-${testId}`}
      title={guidance.text}
    >
      <Compass size={10} weight="bold" className="shrink-0" />
      {guidance.persist && (
        <MapPin size={9} weight="fill" className="shrink-0 text-[#4A5D4E]" />
      )}
      <button
        type="button"
        onClick={onEdit}
        className="truncate hover:underline max-w-[150px] text-left"
        data-testid={`guidance-chip-edit-${testId}`}
      >
        {preview}
      </button>
      <button
        type="button"
        onClick={onClear}
        className="p-0.5 rounded hover:bg-[#DCE6DD] shrink-0"
        data-testid={`guidance-chip-clear-${testId}`}
        title="Clear guidance"
      >
        <X size={9} weight="bold" />
      </button>
    </span>
  );
}
